import {assert} from 'assert-ts';
import type {AgentSubType} from 'types';
import {Concept} from 'types';
import type {AgentTypeDto} from 'api/types';
import {reverseMap} from 'services/utils/functions/reverseMap';

const agentTypeMap: {[dto in AgentTypeDto]: AgentSubType} = {
  PERSON: Concept.person,
  CORPORATION: Concept.corporation,
  PUBLISHER: Concept.publisher,
  EVENT: Concept.event,
};

export const mapAgentTypeDto = (dto: AgentTypeDto): AgentSubType =>
  agentTypeMap[dto];

export const mapToAgentTypeDto = (agentType: AgentSubType): AgentTypeDto => {
  return assert(
    reverseMap(agentType, agentTypeMap),
    'mapToAgentTypeDto: unknown agentType',
    {agentType},
  );
};
